import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import {TYPE_ADGROUP, TYPE_CAMPAIGN} from "../DashboardRow";
import {DatetimeHelper} from "../../../../utils/DatetimeHelper";

// FINISHED, SCHEDULED y NOT_DELIVERING son estados DERIVADOS que calcula el Backend combinando
// el estado configurado con la ventana de fechas y con los grupos de anuncios: no existen en la
// base ni en las APIs de las plataformas. Ver Campaign.delivery_status() en el Backend.
const STATUS_VARIANT = {
    ACTIVE: 'active',
    PAUSED: 'paused',
    FINISHED: 'finished',
    SCHEDULED: 'scheduled',
    NOT_DELIVERING: 'not-delivering',
    ARCHIVED: 'archived',
    REMOVED: 'removed',
    UNKNOWN: 'unknown',
};

// Justamente porque los estados derivados no existen en la plataforma, quien los lee no tiene
// dónde ir a confirmarlos: el tooltip es el único lugar donde se entera de por qué lo decimos.
// La clave y sus parámetros los manda el Backend (Campaign.delivery_status_detail()); acá sólo
// se traducen. PAUSED, ARCHIVED y REMOVED no traen razón: son el estado crudo, se explican solos.
const REASON_KEY = {
    ALL_GROUPS_PAUSED: 'all_groups_paused',
    GROUPS_DELIVERING: 'groups_delivering',
    FINISHED_ON: 'finished_on',
    STARTS_ON: 'starts_on',
};

const UNKNOWN_REASON_KEY = 'dashboard.status_badge.reason.unknown';

class CampaignStatusBadgeCellClass extends Component {
    render() {
        const {status, rowType, t} = this.props;

        // Vacío para BU/BUCC por diseño.
        if (rowType !== TYPE_CAMPAIGN && rowType !== TYPE_ADGROUP) {
            return <td className="single-data -status-badge" />;
        }

        if (!status) {
            return <td className="single-data -status-badge" />;
        }

        const variant = STATUS_VARIANT[status] || STATUS_VARIANT.UNKNOWN;
        const badge = (
            <span className={`status-badge -${variant}`}>
                <span className="status-badge-dot" />
                <span className="status-badge-label">{t(`dashboard.status_badge.${variant}`)}</span>
            </span>
        );

        const tooltip = this.tooltip();
        if (!tooltip) {
            return <td className="single-data -status-badge">{badge}</td>;
        }

        // `warning-tooltip` y no el `title` nativo: es el patrón canónico del repo (CLAUDE.md,
        // "Tooltips") y el que usa la celda de al lado en este mismo switch (PlatformBudgetCell).
        // El nativo no se ve en mobile y no sale en el screenshot que el usuario le manda a
        // soporte — que es justo como llegó el caso que originó este trabajo.
        //
        // `-below-right` y no la posición por defecto. El default (`left: 25px`) está calibrado
        // para un ⓘ de 16px: sobre un badge de ~110px cae ADENTRO del trigger y le tapa la celda
        // al usuario, que es justo la que está mirando. Además `_tables.scss` ya declara
        // `td.single-data .warning-tooltip { right: 0; left: auto }` —los tooltips de esta celda
        // abren hacia la izquierda para no salirse de `.table-box.-dashboard`, que es un
        // contenedor de scroll—, así que lo único que faltaba era bajarlo. `-below-right` da las
        // dos cosas y además da vuelta la flecha para que apunte al badge.
        return (
            <td className="single-data -status-badge">
                <div className="info-icon-container -status-badge-trigger">
                    {badge}
                    <div className="warning-tooltip -below-right">
                        <div className="warning-tooltip-body">
                            <p className="warning-tooltip-text">{tooltip}</p>
                        </div>
                    </div>
                </div>
            </td>
        );
    }

    tooltip() {
        const {status, reason, t} = this.props;

        const reasonKey = REASON_KEY[reason];
        if (reasonKey) {
            const key = `dashboard.status_badge.reason.${reasonKey}`;
            // `escapeValue: false` es obligatorio acá: la fecha viene con BARRAS (08/02/2026) y
            // el default de i18next las convierte en `&#x2F;`, que el usuario leería literal.
            // Es seguro: el destino es un nodo de texto de React, no HTML.
            const texto = t(key, {...this.translationParams(), interpolation: {escapeValue: false}});
            // Sin los parámetros que la clave espera, i18next devuelve la clave en crudo. Antes
            // de mostrarle `dashboard.status_badge.reason.groups_delivering` a un cliente,
            // preferimos no mostrar nada.
            return texto && texto !== key && !texto.startsWith(`${key}_`) ? texto : null;
        }

        // Una fila sincronizada antes de que el Backend empezara a mandar la razón llega sin
        // ella: sin tooltip, que es mejor que inventar uno. Los que sí se aclaran son los dos
        // "no sé": el UNKNOWN que manda el Backend y cualquier estado que no conozcamos.
        if (status === 'UNKNOWN' || !STATUS_VARIANT[status]) {
            return t(UNKNOWN_REASON_KEY);
        }

        return null;
    }

    translationParams() {
        const params = {...(this.props.reasonParams || {})};

        // `count` es lo que i18next mira para elegir singular o plural, y tiene que ser un
        // número: el valor llega de un blob de Firestore, donde un "3" string es posible.
        const total = Number(params.total);
        if (Number.isFinite(total)) {
            params.count = total;
        }
        if (params.date) {
            // Misma razón: si no es una fecha con el formato esperado, el helper tira. Un
            // tooltip con la fecha cruda es mejor que una fila del Tablero que no renderiza.
            try {
                params.date = DatetimeHelper.YYYYMMDDToFriendlyStr(params.date);
            } catch (e) {
                // se deja como vino
            }
        }
        return params;
    }
}

CampaignStatusBadgeCellClass.defaultProps = {
    status: null,
    reason: null,
    reasonParams: null,
};

export const CampaignStatusBadgeCell = withTranslation()(CampaignStatusBadgeCellClass);
